module.exports = __webpack_public_path__ + "img/95dc222.svg";